"use client";

import Error404 from "./Error404";

/** Marker so SelectLayout can detect 404 content without adding another layout. */
function NotFoundPage(props) {
  return <Error404 isNewAppRouter={true} {...props} />;
}

NotFoundPage.is404Page = true;

export default NotFoundPage;
